{
  "name": "@dramadetector/web-landing",
  "version": "0.102.14",
  "private": true,
  "main": "expo-router/entry",
  "scripts": {
    "start": "expo start",
    "android": "expo start --android",
    "ios": "expo start --ios",
    "web": "ENABLE_REANIMATED=false pnpm exec expo start --web",
    "build:android": "eas build --platform android",
    "build:ios": "eas build --platform ios",
    "prebuild:web": "pnpm health:env && rm -rf dist",
    "build:web": "bash -c 'set -o pipefail && EXPO_PLATFORM=web expo export --platform web --source-maps 2>&1 | tee build.log' || (tsx scripts/report-build-error.ts build.log && exit 1)",
    "cache:clear": "rm -rf .expo node_modules/.cache",
    "build:web:clean": "pnpm cache:clear && bash -c 'set -o pipefail && EXPO_PLATFORM=web expo export --platform web --source-maps --clear 2>&1 | tee build.log && cp -r public/locales dist/ && cp public/_redirects dist/_redirects && cp public/_headers dist/_headers && cp public/_routes.json dist/_routes.json' || (tsx scripts/report-build-error.ts build.log && exit 1)",
    "sentry:release": "COMMIT_SHA=${CF_PAGES_COMMIT_SHA:-$VERCEL_GIT_COMMIT_SHA} && [ -z \"$COMMIT_SHA\" ] && echo 'No commit SHA available, skipping Sentry release' && exit 0 || SHORT_SHA=$(echo $COMMIT_SHA | cut -c1-7) && RELEASE_NAME=\"drama-detector-$SHORT_SHA\" && sentry-cli releases new $RELEASE_NAME --project drama-web && sentry-cli sourcemaps upload --release=\"$RELEASE_NAME\" --dist=\"$COMMIT_SHA\" --project=drama-web ./dist && (sentry-cli releases set-commits $RELEASE_NAME --auto --project drama-web || sentry-cli releases set-commits $RELEASE_NAME --commit=\"Liftping/drama-detector@$COMMIT_SHA\" --project drama-web) && sentry-cli releases finalize $RELEASE_NAME --project drama-web || echo 'Sentry release failed (non-blocking)'",
    "build:web:production": "cd ../../packages/shared && pnpm build && cd ../../apps/mobile && ALLOW_TIER_OVERRIDE=${ALLOW_TIER_OVERRIDE:-false} EXPO_PUBLIC_API_BASE_URL=${EXPO_PUBLIC_API_BASE_URL} EXPO_PLATFORM=web pnpm run build:web:clean && pnpm run sentry:release",
    "serve:static": "npx serve dist -s -l 3000",
    "health:env": "tsx scripts/validate-env.ts",
    "health:third-party": "tsx scripts/health-check-services.ts",
    "health:all": "pnpm health:env && pnpm health:third-party",
    "test": "jest",
    "test:e2e": "playwright test",
    "test:e2e:ui": "playwright test --ui",
    "test:e2e:debug": "playwright test --debug",
    "test:e2e:report": "playwright show-report",
    "test:e2e:local": "cross-env PLAYWRIGHT_BASE_URL=http://localhost:3000 playwright test",
    "test:e2e:staging": "playwright test --project=staging-only",
    "test:e2e:tier-1": "playwright test --project=tier-1-critical",
    "test:e2e:tier-2": "playwright test --project=tier-2-trust",
    "test:e2e:tier-3": "playwright test --project=tier-3-experience",
    "test:e2e:tier-4": "playwright test --project=tier-4-polish",
    "test:e2e:deploy-gate": "playwright test --project=deploy-gate",
    "test:e2e:reset-quotas": "cd ../.. && npx tsx apps/mobile/scripts/reset-test-quotas.ts",
    "test:e2e:verify-users": "cd ../.. && npx tsx apps/mobile/scripts/verify-test-users.ts",
    "test:e2e:cache": "cd ../.. && npx tsx apps/mobile/scripts/reset-test-quotas.ts --tier=dramax && cd apps/mobile && cross-env PLAYWRIGHT_BASE_URL=https://st.dramadetector.com playwright test tests/e2e/unified-pipeline/cache-validation.spec.ts",
    "test:e2e:metrics": "npx tsx scripts/publish-e2e-metrics.ts",
    "test:pipeline:phase1": "playwright test tests/e2e/unified-pipeline/anonymous-tier.spec.ts tests/e2e/unified-pipeline/provider-failover.spec.ts --project=chromium-desktop",
    "test:pipeline:phase1:ui": "playwright test tests/e2e/unified-pipeline/anonymous-tier.spec.ts tests/e2e/unified-pipeline/provider-failover.spec.ts --ui",
    "test:pipeline:cache": "playwright test tests/e2e/unified-pipeline/cache-validation-*.spec.ts tests/e2e/unified-pipeline/cache-debug.spec.ts --project=chromium-desktop",
    "test:pipeline:all": "playwright test tests/e2e/unified-pipeline/ --project=chromium-desktop",
    "test:pipeline:ui": "playwright test tests/e2e/unified-pipeline/ --ui",
    "test:pipeline:debug": "playwright test tests/e2e/unified-pipeline/ --debug",
    "serve:local": "npx http-server dist -p 3000 -a 127.0.0.1 --proxy http://127.0.0.1:3000?",
    "lint": "echo 'Skipping lint (no eslint config)'",
    "type-check": "echo '✓ TypeScript pinned to 5.9.2 (root pnpm override)' && echo '📝 IDE TypeScript server for development type checking' && echo '✅ Metro bundler validates types during build' && echo '🔗 Guard: pnpm check:ts-version (root package.json)'",
    "update:preview": "eas update --channel preview --message",
    "update:production": "eas update --channel production --message",
    "update:rollback:preview": "eas update --channel preview --rollback-to-embedded",
    "update:rollback:production": "eas update --channel production --rollback-to-embedded",
    "update:status": "eas update:list --branch production --limit 10"
  },
  "dependencies": {
    "@babel/runtime": "^7.29.2",
    "@better-auth/expo": "1.5.6",
    "@dramadetector/api-client": "workspace:*",
    "@dramadetector/shared": "workspace:*",
    "@dramadetector/ui": "workspace:*",
    "@expo-google-fonts/inter": "^0.4.2",
    "@expo-google-fonts/plus-jakarta-sans": "^0.4.2",
    "@expo/dom-webview": "~57.0.1",
    "@expo/metro-runtime": "~57.0.15",
    "@expo/vector-icons": "^15.1.1",
    "@hookform/resolvers": "^5.2.2",
    "@polar-sh/sdk": "^0.46.3",
    "@react-native-masked-view/masked-view": "^0.3.2",
    "@react-navigation/native": "^7.1.33",
    "@sentry/core": "~10.73.0",
    "@sentry/react-native": "~8.25.0",
    "@shopify/flash-list": "2.0.2",
    "@tanstack/react-query": "^5.90.19",
    "@tanstack/react-query-persist-client": "^5.90.7",
    "better-auth": "1.6.26",
    "cross-env": "^10.1.0",
    "date-fns": "^4.1.0",
    "expo": "~57.0.20",
    "expo-blur": "~57.0.2",
    "expo-clipboard": "~57.0.1",
    "expo-constants": "~57.0.17",
    "expo-crypto": "~57.0.2",
    "expo-font": "~57.0.3",
    "expo-linear-gradient": "~57.0.1",
    "expo-linking": "~57.0.9",
    "expo-localization": "~57.0.1",
    "expo-network": "~57.0.1",
    "expo-router": "~57.0.19",
    "expo-sharing": "~57.0.18",
    "expo-status-bar": "~57.0.1",
    "expo-web-browser": "~57.0.2",
    "i18next": "^26.4.2",
    "nativewind": "^4.2.6",
    "posthog-js": "^1.320.0",
    "posthog-react-native": "^3.16.1",
    "react": "19.2.3",
    "react-dom": "19.2.3",
    "react-hook-form": "^7.71.1",
    "react-i18next": "^17.0.13",
    "react-native-css-interop": "^0.2.6",
    "react-native-gesture-handler": "~2.32.0",
    "react-native-reanimated": "4.5.1",
    "react-native-screens": "~4.26.0",
    "react-native-svg": "15.15.4",
    "react-native-view-shot": "5.1.0",
    "react-native-webview": "13.16.1",
    "react-native-worklets": "0.10.1",
    "tailwindcss": "^3.4.18",
    "web-vitals": "^5.1.0",
    "zod": "^4.3.6",
    "zustand": "^5.0.11"
  },
  "devDependencies": {
    "@axe-core/playwright": "^4.11.1",
    "@babel/core": "^7.29.0",
    "@babel/plugin-transform-modules-commonjs": "^7.28.6",
    "@playwright/test": "1.58.2",
    "@react-native-async-storage/async-storage": "2.2.0",
    "@react-native/metro-config": "0.86.3",
    "@sentry/browser": "~10.73.0",
    "@sentry/cli": "^2.58.5",
    "@testing-library/react-native": "^13.3.3",
    "@types/jest": "29.5.14",
    "@types/node": "^26.5.0",
    "@types/react": "~19.2.0",
    "dotenv": "^17.2.3",
    "jest": "^29.7.0",
    "jest-expo": "~57.0.5",
    "msw": "2.12.10",
    "react-native": "0.86.3",
    "react-native-safe-area-context": "~5.7.0",
    "react-native-web": "~0.21.2",
    "react-test-renderer": "19.2.3",
    "serve": "^14.2.6",
    "tsx": "^4.20.6",
    "typescript": "5.9.2"
  }
}
